import React from "react";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles, Theme } from "@material-ui/core";

import "./styles.scss"


interface TabControlProps {
  currentTabName: string;
  onChangeTab: (value: string) => void;
  indicatorColor?: "primary" | "secondary";
  textColor?: "inherit" | "primary" | "secondary";
  fixHeader?: boolean;
}

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  hidden: {
    display: "none",
  },
}));

const TabControl: React.FC<TabControlProps> = ({
  currentTabName,
  onChangeTab,
  children,
  indicatorColor = "secondary",
  textColor = "secondary",
  fixHeader = false,
}) => {
  const classes = useStyles();

  const onChangeTabInternal = (event: React.ChangeEvent<{}>, value: string) => {
    onChangeTab(value);
  };

  const TabChildren = React.Children.map(children, (tab: any, index: number) => {
    return React.cloneElement(tab, {
      className: (tab?.props?.className || "") + `${fixHeader ? " fixed-header" : ""} `,
      name: tab.props.name,
      currentTabName: currentTabName,
      visible: tab.props.visible,
      key: `tab-${tab.props.name}-${index}`
    });
  });

  return (
    <AppBar className={`TabControl${fixHeader ? " fixedHeader" : ""}`} position={fixHeader ? "sticky" : "static"} color="transparent" elevation={0}>
      <Tabs
        className={`tabs-header${fixHeader ? " fixed" : ""}`}
        value={currentTabName}
        onChange={onChangeTabInternal}
        indicatorColor={indicatorColor}
        textColor={textColor}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {React.Children.map(children, (tab: any) => {
          return (
            <Tab
              value={tab.props.name}
              label={tab.props.label}
              disabled={!tab.props.visible}
              className={(!tab.props.visible ? classes.hidden : "") + `${fixHeader ? " fixedHeader" : ""}`}
              {...a11yProps(tab.props.name)}
            />
          );
        })}
      </Tabs>
      {TabChildren}
    </AppBar>
  );
};

export { TabControl };
